<section class="best-sellers-section">
    <div class="generic-container best-sellers-container">
        <div class="section-header">
            <h2 class="section-title">
                Best
                <span class="highlight-gradient-text1"> Sellers</span>
            </h2>
            <p class="section-description">
                Explore our most-loved toys that kids and parents can't stop talking about
            </p>
        </div>

        <div class="products-grid">
            <div
                *ngFor="let product of bestSellerProducts; let i = index"
                class="product-wrapper animate-fade-in"
                [ngStyle]="{ animationDelay: i * 0.1 + 's' }"
            >
                <app-product-card [product]="product"></app-product-card>
            </div>
        </div>

        <div class="view-all-section">
            <a
                routerLink="/products"
                [queryParams]="{ category: 'bestSeller' }"
                class="view-all-link transition-colors"
            >
                View All Best Sellers
                <mat-icon
                    aria-hidden="false"
                    aria-label="arrow icon"
                    fontIcon="arrow_forward"
                    class="arrow-icon"
                ></mat-icon>
            </a>
        </div>
    </div>
</section>
